import { render, staticRenderFns } from "./GLTF.vue?vue&type=template&id=123d8dd2&"
import script from "./GLTF.vue?vue&type=script&lang=js&"
export * from "./GLTF.vue?vue&type=script&lang=js&"
import style0 from "./GLTF.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports